import React, { useState } from "react";
import { Observer } from "mobx-react";
import {
  InputAdornment,
  OutlinedInput,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import { Save } from "@material-ui/icons";
import { CustomerType, useGetCustomerRecommendedPricesQuery } from "@graphql";
import { store } from "@store";
import { Form, Input } from "@components/formx";
import { Actions, PrimaryButton } from "@components";
import { useForm } from "./useForm";

type Props = {
  customerId: string;
};

export function CustomerRecommendedPrice(props: Props) {
  const { form, getItemIndex, reset } = useForm(props.customerId);
  const [notSupported, setNotSupported] = useState(false);

  useGetCustomerRecommendedPricesQuery({
    variables: { customerId: props.customerId },
    fetchPolicy: "network-only",
    onCompleted: (res) => {
      if (res.customerById.Type === CustomerType.Region) {
        return setNotSupported(true);
      }

      if (res.customerById.Type !== CustomerType.Hospital) {
        form.disabled = true;
      }

      reset(res.customerById.recommendedPrices);
    }
  });

  const professions = store().cache.professions.sortBy((x) => x);

  if (notSupported) {
    return (
      <div style={{ padding: 16, textAlign: "center" }}>
        <Typography>Not supported for Organisations</Typography>
      </div>
    );
  }

  return (
    <Form store={form}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Område</TableCell>
            <TableCell style={{ width: "15rem" }}>Rekommenderad lön</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {professions.map((profession) => {
            const aoes = store().cache.getAreaOfExpOnProfessions([profession]);

            if (aoes.length === 1 && profession === aoes[0].Name) {
              const index = getItemIndex(profession, aoes[0].Name);

              return (
                <TableRow hover>
                  <TableCell style={{ textAlign: "left", fontWeight: "bold" }}>
                    {profession}
                  </TableCell>
                  <TableCell style={{ width: "10rem" }}>
                    <Input
                      name={`items.${index}.value`}
                      Component={OutlinedInput}
                      InputProps={{
                        margin: "dense",
                        endAdornment: <InputAdornment position="end">kr.</InputAdornment>,
                        inputProps: {
                          style: { textAlign: "right" }
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            }

            return (
              <React.Fragment key={profession}>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    style={{ textAlign: "left", fontWeight: "bold" }}
                  >
                    {profession}
                  </TableCell>
                </TableRow>

                {aoes.map((areaOfExpertise) => {
                  const index = getItemIndex(profession, areaOfExpertise.Name);

                  return (
                    <TableRow key={areaOfExpertise.Name} hover>
                      <TableCell>{areaOfExpertise.Name}</TableCell>
                      <TableCell style={{ width: "10rem" }}>
                        <Input
                          name={`items.${index}.value`}
                          Component={OutlinedInput}
                          InputProps={{
                            margin: "dense",
                            endAdornment: (
                              <InputAdornment position="end">kr.</InputAdornment>
                            ),
                            inputProps: {
                              style: { textAlign: "right" }
                            }
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </React.Fragment>
            );
          })}

          <Observer>
            {() => (
              <TableRow>
                <TableCell colSpan={2}>
                  <Actions>
                    <PrimaryButton
                      leftIcon={<Save />}
                      disabled={!form.canSubmit}
                      style={{ marginLeft: "auto" }}
                      loading={form.isSubmitting}
                      onClick={form.submit}
                    >
                      Spara
                    </PrimaryButton>
                  </Actions>
                </TableCell>
              </TableRow>
            )}
          </Observer>
        </TableBody>
      </Table>
    </Form>
  );
}
